import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        width: "100%",
        padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
        borderBottom: `1px solid ${theme.palette.border.main}`,
    },
    title: {
        color: theme.palette.text.secondary,
    },
    progressBar: {
        width: "100%",
        display: "flex",
        alignItems: "center",
    },
    machineTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
    },
    percentagesContainter: {
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
    downtime: {
        height: 12,
        backgroundColor: theme.palette.error.main,
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
    },
    downtimeTitle: {
        color: theme.palette.error.main,
    },
    uptime: {
        height: 12,
        backgroundColor: theme.palette.success.main,
        borderTopLeftRadius: 50,
        borderBottomLeftRadius: 50,
        textAlign: "right",
        marginRight: theme.spacing(0.5),
    },
    uptimeTitle: {
        color: theme.palette.success.main,
    },
}));
